import React from "react";
import { Icon } from "@iconify/react";
import Link from "next/link";

const cards = [
  {
    title: "Complete Missions",
    subtitle: "Earn points by completing quests",
    description:
      "Play our games and complete missions to earn MXS points and climb the leaderboard.",
    button: "View Available Missions",
    link: "/missions",
    icon: (
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-zinc-700 text-zinc-100 mr-3">
        <svg
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4l3 3" />
        </svg>
      </span>
    ),
    bg: "bg-zinc-800",
    border: "border-zinc-700",
    text: "text-zinc-100",
    buttonClass:
      "bg-zinc-700 text-white hover:bg-zinc-800 border border-zinc-600",
  },
  {
    title: "Buy XSeed",
    subtitle: "Acquire XSeed tokens to boost your MXS",
    description:
      "Purchase tokens to receive proportional MXS points and qualify for the season airdrop.",
    button: "Purchase XSEED",
    link: "https://lfj.gg/avalanche/swap?inputCurrency=AVAX&outputCurrency=0x0A10D108E2d81ccC793E37b56206C84bF96ddc57",
    icon: (
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-yellow-900/30 text-yellow-300 mr-3">
        <svg
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4l3 3" />
        </svg>
      </span>
    ),
    bg: "bg-zinc-800",
    border: "border-zinc-700",
    text: "text-zinc-100",
    buttonClass:
      "bg-zinc-700 text-white hover:bg-zinc-800 border border-zinc-600",
  },
  {
    title: "Buy Nodes",
    subtitle: "Buy Nodes to earn MXS points",
    description:
      "Purchase nodes and earn daily XSEED and MXS points for upto 10 years.",
    button: "Purchase Nodes",
    link: "/nodes",
    icon: (
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-green-900/30 text-green-300 mr-3">
        <svg
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8v4l3 3" />
        </svg>
      </span>
    ),
    bg: "bg-zinc-800",
    border: "border-zinc-700",
    text: "text-zinc-100",
    buttonClass:
      "bg-zinc-700 text-white hover:bg-zinc-800 border border-zinc-600",
  },
];

export default function BoostYourScore() {
  return (
    <div className="bg-[#1a1a1a] rounded-2xl border border-zinc-700 p-8 w-full mt-8">
      <div className="mb-6 text-left">
        <div className="flex items-center gap-2 mb-1">
          <div className="text-2xl font-bold text-white flex items-center gap-2">
            <Icon
              icon="streamline:graph-bar-increase-solid"
              className="h-6 w-6"
            />
            Boost Your Score
          </div>
        </div>
        <div className="text-zinc-400 text-base">
          Take action to increase your MXS points and climb the leaderboard
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map((card, i) => (
          <div
            key={i}
            className={`rounded-xl border ${card.bg} ${card.border} p-6 flex flex-col items-start shadow-md`}
          >
            <div className="flex items-center mb-3">
              {card.icon}
              <span className="text-xl font-bold text-zinc-100">
                {card.title}
              </span>
            </div>
            <div className="text-zinc-400 font-medium mb-1">
              {card.subtitle}
            </div>
            <div className="text-zinc-400 mb-6 text-left">
              {card.description}
            </div>
            <Link
              href={card.link}
              target={card.link.startsWith("http") ? "_blank" : undefined}
              rel={
                card.link.startsWith("http") ? "noopener noreferrer" : undefined
              }
              className={`mt-auto w-full py-2 rounded-lg font-semibold flex items-center justify-center gap-2 ${card.buttonClass}`}
            >
              {card.button}
              <svg
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
